import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface ContainerProps {
  children: ReactNode;
  className?: string;
}

/**
 * Container component for applying consistent horizontal padding.
 */
export function Container({
  children,
  className,
}: ContainerProps) {
  return (
    <div className={cn("w-full", className)}>
      {children}
    </div>
  );
}
